export default __webpack_public_path__ + "static/media/bg-tablet.64327d58.jpg";